<div class="fdx-o-grid__row">
  <div
    class="fdx-u-mb--10 fdx-u-p--6 fdx-u-elevation--z2 fdx-o-grid__item fdx-o-grid__item--12@large fdx-u-align--center fdx-u-bg-color--grey--light-1">
    @if (!messageFlag || deviceInfoFlag) {
      <p class="fdx-c-paragraph fdx-u-font-size--h5" id="callFailMsg">
        {{'login.loginCallFailMessage' | translate}}
      </p>
    }
    @if (messageFlag) {
      <p class="fdx-c-paragraph fdx-u-font-size--h6" id="profileLockedMsg">
        {{ 'login.loginProfileLockedMsg' | translate}}
      </p>
    }
  </div>
</div>